/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {onboardingInternalRoute} from '../api'

export const useMutationOnboardingInternalRoute = createReactQueryMutationHook('onboardingInternalRoute', onboardingInternalRoute)
